import FormGroup from "legacy/FormGroup"
import DisableAutoRenewModal from "legacy/manage/DisableAutoRenewModal"
import _ from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

class ItinerarySection extends React.Component {
  renderSpaceTypeChooser() {
    if (!this.props.disabledSpaceType) {
      return (
        <div
          className={
            this.props.disabledRevenueCategory ? "col-sm-4" : "col-sm-6"
          }
        >
          <FormGroup
            inputType="select"
            label="Space type"
            name="spaceType"
            value={this.props.spaceType}
            onChange={this.props.handleInputChange}
          >
            {_.map(this.props.spaceTypes, (type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </FormGroup>
        </div>
      )
    }
    return null
  }

  renderRevenueCategoryChooser() {
    if (!this.props.disabledRevenueCategory) {
      return (
        <div className="col-sm-6">
          <FormGroup
            disabled={true}
            inputType="select"
            label="Revenue Category"
            name="revenueCategoryId"
            value={this.props.revenueCategoryId}
            onChange={this.props.handleInputChange}
          >
            <option key="blank" value="">
              None specified
            </option>
            {_.map(this.props.revenueCategories, (category) => (
              <option key={category.id} value={category.id}>
                {category.displayName}
              </option>
            ))}
          </FormGroup>
        </div>
      )
    }
    return null
  }

  render() {
    return (
      <span>
        <div className="row form-row">
          <div
            className={
              this.props.disabledRevenueCategory ? "col-sm-4" : "col-sm-6"
            }
          >
            <FormGroup
              inputType="datepicker"
              label={this.props.startName || "Arrival"}
              name="arrival"
              value={this.props.arrival}
              onChange={this.props.handleArrivalChange}
              validation={
                this.props.validator
                  ? this.props.validator.message(
                      "Arrival",
                      this.props.arrival,
                      "required"
                    )
                  : null
              }
            />
          </div>
          <div
            className={
              this.props.disabledRevenueCategory ? "col-sm-4" : "col-sm-6"
            }
          >
            {this.props.autoRenewEnabled ? (
              <div className="mt-7 flex flex-row">
                <DisableAutoRenewModal
                  arrival={this.props.arrival}
                  departure={this.props.departure}
                  disableAutoRenewEndPoint={this.props.disableAutoRenewEndPoint}
                />
                <i
                  className="fa-kit fa-info cursor-pointer px-2 text-xs text-gray-500"
                  data-container="body"
                  data-toggle="popover"
                  data-placement="top"
                  data-content="Contract will renew automatically each month until turned off. This action cannot be undone."
                />
              </div>
            ) : (
              <FormGroup
                inputType="datepicker"
                label={this.props.endName || "Departure"}
                name="departure"
                value={this.props.departure}
                onChange={this.props.handleDepartureChange}
                startDate={this.props.arrival}
                endDate={
                  this.props.isTransient
                    ? moment(this.props.arrival).add(1, "year")
                    : null
                }
                disabled={this.props.disableDepartureDate}
                validation={
                  this.props.validator
                    ? this.props.validator.message(
                        "Departure",
                        this.props.departure,
                        "required"
                      )
                    : null
                }
              />
            )}
          </div>
          {this.props.disabledRevenueCategory && this.renderSpaceTypeChooser()}
        </div>
        {!this.props.disabledRevenueCategory && (
          <div className="row form-row">
            {this.renderSpaceTypeChooser()}
            {this.renderRevenueCategoryChooser()}
          </div>
        )}
      </span>
    )
  }
}

ItinerarySection.propTypes = {
  arrival: PropTypes.string,
  departure: PropTypes.string,
  startName: PropTypes.string,
  endName: PropTypes.string,
  spaceType: PropTypes.string,
  spaceTypes: PropTypes.array,
  disabledSpaceType: PropTypes.bool,
  handleInputChange: PropTypes.func.isRequired,
  handleArrivalChange: PropTypes.func.isRequired,
  handleDepartureChange: PropTypes.func.isRequired,
  disableDepartureDate: PropTypes.bool,
  disabledRevenueCategory: PropTypes.bool,
  revenueCategories: PropTypes.array,
  revenueCategoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  autoRenewEnabled: PropTypes.bool,
  disableAutoRenewEndPoint: PropTypes.string,
  isTransient: PropTypes.bool,
  validator: PropTypes.object,
}

export default ItinerarySection
